import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const EquipmentManagementPage = lazyWithRetry(
  () => import("./ui/pages/EquipmentManagementPage"),
  "EquipmentManagementPage",
);

/**
 * Rutas de gestión de equipo de protección
 * Accesible por Inspector (2) y Developer (5)
 */
const equipmentRoutes = buildRoutes([
  {
    path: "/inspector/equipment",
    element: EquipmentManagementPage,
    roles: [1, 2, 5],
  },
]);

export default equipmentRoutes;
